import React from "react";
import { GiftCardDetailsPage } from "../../Components/dashboard";

const AdminGiftCardDetails = () => {
  return <GiftCardDetailsPage role="admin" />;
};

export default AdminGiftCardDetails;
